import React from 'react';

import { useLDClient } from 'launchdarkly-react-client-sdk';

import { GoogleTagManagerSnippet } from '@techstyle/react-marketing';

export function LaunchDarklyExperimentVariables({ dataLayerName }) {
  const ldClient = useLDClient();
  const allFlags = ldClient?.allFlags() ?? {};

  return Object.keys(allFlags).map(flag => {
    const variationDetail = ldClient.variationDetail(flag);

    if (variationDetail.reason?.inExperiment) {
      const data = {
        event: 'InLaunchDarklyExperiment',
        eventCategory: 'Launch Darkly AB Test Key',
        eventAction: flag,
        eventLabel: variationDetail.value,
      };

      return (
        <GoogleTagManagerSnippet.Push
          key={flag}
          dataLayerName={dataLayerName}
          data={data}
        />
      );
    }
  });
}
